import React, { Component } from 'react'
import PropTypes from "prop-types"
import { connect } from 'react-redux'
import moment from "moment"

import LineGraph from "visualizations/components/LineGraph"

import { lineWrapperProps } from 'search-new/selectors'

export class LineWrapper extends Component {
    static propTypes = {
        // from ListViewDisplayWrapper
        uniqueFlvId: PropTypes.string.isRequired,
        uniqueVizSceneId: PropTypes.string.isRequired,
        // from containers/VisualizationDisplay/index
        isVisualizationLoading: PropTypes.bool.isRequired,
        isVisualizationDataEmpty: PropTypes.bool.isRequired,
        // from components/VisualizationDisplay/index (modified)
        updateFilter: PropTypes.func.isRequired,
        secondaryGraphKeys: PropTypes.object.isRequired,
        // from connect
        dateData: PropTypes.object.isRequired,
        storedGraphData: PropTypes.array.isRequired,
        graphCountMax: PropTypes.number.isRequired,
        graphDateRange: PropTypes.object.isRequired,
        graphDerivedData: PropTypes.array.isRequired,
        showCurrentSearchInLegend: PropTypes.bool.isRequired,
    }

    constructor(props) {
        super(props)
        this.updateGraph = this.updateGraph.bind(this)
    }

    updateGraph(startDate, endDate) {
        this.props.updateFilter({
            dateStart: startDate,
            dateEnd: endDate,
        })
    }

    render() {
        return (
            <LineGraph
                data={this.props.dateData.toJS()}
                storedData={this.props.storedGraphData}
                startDate={this.props.graphDateRange.start}
                endDate={this.props.graphDateRange.end}
                maxCount={this.props.graphCountMax}
                showCurrentSearchInLegend={this.props.showCurrentSearchInLegend}
                graphDerivedData={this.props.graphDerivedData}
                updateGraph={this.updateGraph}
                isLoading={this.props.isVisualizationLoading}
                svgId={this.props.uniqueVizSceneId}
            />
        )
    }
}

export default connect(lineWrapperProps, null)(LineWrapper)
